module.exports = __webpack_public_path__ + "static/dining-c2d5c3643bfb6e71a49e1b2f3fc80349.jpg";